import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { X } from 'lucide-react';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const location = useLocation();

  // Don't show in admin area
  const isAdminArea = location.pathname.startsWith('/admin');

  useEffect(() => {
    // Never show in admin area
    if (isAdminArea) {
      setShowBanner(false);
      return;
    }

    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      // Show banner after 1 second
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [isAdminArea]);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setShowBanner(false);
  };

  // Don't show in admin or if banner is hidden
  if (!showBanner || isAdminArea) return null;

  const bannerContent = (
    <div 
      style={{
        position: 'fixed',
        bottom: '0',
        left: '0',
        right: '0',
        zIndex: 40,
        padding: '12px 12px 16px 12px',
        pointerEvents: 'none'
      }}
    >
      <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-2xl border-2" style={{ borderColor: '#C4A084', pointerEvents: 'auto' }}>
        <div className="p-4 md:p-6 md:flex md:items-center md:justify-between">
          <div className="flex-1 mb-3 md:mb-0 md:mr-6 pr-8 md:pr-0">
            <h3 className="text-base md:text-lg font-semibold mb-1 md:mb-2" style={{ color: '#6D5A47' }}>
              🍪 Cookie-Hinweis
            </h3>
            <p className="text-xs md:text-sm text-gray-600 mb-1 md:mb-2">
              Wir verwenden technisch notwendige Cookies (z.B. Warenkorb, Login). Mit „Akzeptieren“
              erlaubst du zusätzlich anonyme Statistik (PostHog) und – falls aktiviert – Google-Dienste,
              damit wir den Shop verbessern können. Mit „Ablehnen“ bleiben nur die notwendigen Cookies aktiv.
            </p>
            <p className="text-xs text-gray-500">
              Weitere Informationen finden Sie in unserer{' '}
              <Link to="/datenschutz" className="text-blue-600 hover:underline">
                Datenschutzerklärung
              </Link>
              .
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 md:flex-shrink-0">
            <Button
              onClick={handleAccept}
              className="bg-gradient-to-r from-[#C4A084] to-[#B89968] text-white hover:opacity-90"
              size="sm"
            >
              Akzeptieren
            </Button>
            <Button
              onClick={handleDecline}
              variant="outline"
              className="border-2"
              style={{ borderColor: '#C4A084', color: '#8B7355' }}
              size="sm"
            >
              Ablehnen
            </Button>
          </div>

          <button
            onClick={handleDecline}
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 p-1"
            aria-label="Schließen"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );

  // Use React Portal to render directly into body, bypassing any parent transforms
  return ReactDOM.createPortal(bannerContent, document.body);
};

export default CookieBanner;
